import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";

import { db } from "../Config/firebase";

export default function KPIListaPorEscopo() {
  const history = useHistory();
  const [kpis, setKpis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");

  const tipoUsuario =
    (localStorage.getItem("tipoUsuario") || "cliente").toLowerCase();

  useEffect(() => {
    carregarKPIs();
    // eslint-disable-next-line
  }, []);

  async function carregarKPIs() {
    try {
      setLoading(true);
      setErro("");

      const q = query(
        collection(db, "kpis"),
        where("ativo", "==", true),
        where("escopo", "==", tipoUsuario)
      );

      const snap = await getDocs(q);

      const lista = snap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));

      setKpis(lista);
    } catch (e) {
      console.error("Erro ao carregar KPIs:", e);
      setErro("Erro ao carregar pesquisas.");
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <div className="container mt-4">Carregando pesquisas...</div>;
  }

  if (erro) {
    return <div className="container mt-4 alert alert-danger">{erro}</div>;
  }

  if (kpis.length === 0) {
    return (
      <div className="container mt-4 alert alert-warning">
        Nenhuma pesquisa disponível para seu perfil.
      </div>
    );
  }

  return (
    <div className="container mt-4" style={{ maxWidth: 800 }}>
      <h4 className="mb-4">Pesquisas disponíveis</h4>

      <div className="list-group">
        {kpis.map(kpi => (
          <button
            key={kpi.id}
            className="list-group-item list-group-item-action"
            onClick={() => history.push(`/app/pesquisa/${kpi.id}`)}
          >
            <div className="fw-bold">{kpi.nome}</div>
            {kpi.descricao && (
              <div className="text-muted small mt-1">
                {kpi.descricao}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
